import { setLoading } from "../generalActions/mainActions";
import { addItem, changeListItem, removeItem, setItems, setTableParams } from "../generalActions/listActions";
import { setForm, setItem } from "../generalActions/formActions";
import {placeService} from "../../../jwt/_services/hotel/placeService";

export const search = (pageIndex, pageSize, filter) => ( dispatch ) => {
    dispatch(setLoading(true))

    placeService.search(pageIndex, pageSize, filter)
        .then(result => {
            if (!result)
                return

            dispatch(setItems(result.data))
            dispatch(setTableParams(pageSize, pageIndex, result?.total))
        })
        .finally(() => dispatch(setLoading(false)))
}

export const save = data => ( dispatch ) => {
    dispatch(setLoading(true))

    placeService.saveItem(data)
        .then( result => {
            if(!result)
                return

            dispatch( setItem(result) )
            dispatch( setForm(false, true, true) )
            dispatch( addItem(result) )
        })
        .finally(() => dispatch(setLoading(false)))
}

export const update = (id, data) => ( dispatch ) => {
    dispatch(setLoading(true))

    placeService.updateItem(id, data)
        .then( result => {
            if(!result)
                return

            dispatch( setItem(result) )
            dispatch( setForm(false, true, true) )
            dispatch( changeListItem(result) )
        })
        .finally(() => dispatch(setLoading(false)))
}

export const remove = (id, fbDdataBase) => ( dispatch ) => {
    dispatch(setLoading(true))

    placeService.deleteItem(id, fbDdataBase)
        .then( result => {
            if(result?.status)
                dispatch( removeItem(id) )
        })
        .finally(() => dispatch(setLoading(false)))
}

export const syncGallery = (dataRequest) => ( dispatch ) => {
    dispatch(setLoading(true))

    placeService.syncGallery(dataRequest).then( result =>{
        console.log("result:.",{result})
    }).finally(() => dispatch(setLoading(false)))
}